import * as Widgets from '@mm/constants/widgets';
import ButtonStackWidget from './ButtonStackWidget';

export default class OptInWidget extends ButtonStackWidget {
  static make(pageId: number, sortOrder: number) {
    const widget = {
      ...super.make(pageId, Widgets.OPT_IN, sortOrder),
      config: {
        body: '',
      },
    };

    delete widget.label;

    return widget;
  }
}
